Librarian.ModuleLoader3 = new Class({
    Implements: [Options, Events],
    Binds: ["render", "renderRow", "renderCell", "renderModule"],

    options: {
        container: "homepage",
        title: null,
        width: null,
        maxWidth: null,
        moduleSpacing: null,
        modulePadding: null,
        moduleWidth: null,
        moduleHeight: null
    },

    className: "page-layout",
    containerEl: null,

    modules: {},

    eventHandler: null,

    initialize: function(options) {
        this.setOptions(options);

        if (!this.options.container)
            return;

        this.containerEl = $(this.options.container);
        this.eventHandler = new Events();
    },

    load: function(layout) {
        this.layout = layout;

        this.render();
    },

    render: function() {
        var self = this;

        this.containerEl.empty();
        this.containerEl.removeClass("pure-g-r");

        this.createDashboard();

        if (this.options.title)
            this.createHeader();

        this.layout.sections.forEach(function(section) {
            self.renderSection(section);
        });
    },

    createDashboard: function() {
        this.dashboardEl = new Element("div", {
            "class": this.className + "-dashboard"
        }).inject(this.containerEl);

        this.dashboardEl.setStyles({
            "width": this.getSizeValue(this.options.width),
            "maxWidth": this.getSizeValue(this.options.maxWidth)
        });

        // TODO: moduleSpacing
    },
    
    createHeader: function() {
        var header = new Element("div", {
            "class": this.className + "-header"
        }).inject(this.dashboardEl);

        var title = new Element("div", {
            "class": this.className + "-title",
            "text": this.options.title
        }).injectInside(header);
    },

    renderSection: function(section) {
        var sectionEl = this.createSection(section),
            self = this;

        section.columns.forEach(function(column) {
            self.renderColumn(column, sectionEl);
        });
    },

    createSection: function(section) {
        var sectionEl = new Element("div", {
            "class": this.className + "-section"
        }).injectInside(this.dashboardEl);
        
        if (section.style) {
            var styles = this.parseStyles(section.style);

            sectionEl.setStyles(styles);
        }

        return sectionEl;
    },

    renderColumn: function(column, sectionEl) {
        var columnEl = this.createColumn(column, sectionEl),
            self = this;

        column.modules.forEach(function(module) {
            self.renderItem(module, columnEl);
        });
    },

    createColumn: function(column, sectionEl) {
        var columnEl = new Element("div", {
            "class": this.className + "-column"
        }).injectInside(sectionEl);

        if (column.style) {
            var styles = this.parseStyles(column.style);

            columnEl.setStyles(styles);
        }

        return columnEl;
    },

    renderItem: function(moduleInfo, columnEl) {
        var item = this.createItem(moduleInfo, columnEl);

        this.renderModule(moduleInfo, item);
    },

    createItem: function(moduleInfo, columnEl) {
        var item = new Element("div", {
            "class": this.className + "-item"
        }).injectInside(columnEl);

        if (this.options.modulePadding)
            item.setStyle("padding", this.getSizeValue(this.options.modulePadding));

        if (moduleInfo.style) {
            var styles = this.parseStyles(moduleInfo.style);

            item.setStyles(styles);
        }

        return item;
    },

    renderModule: function(moduleInfo, item) {
        var moduleWrapper = new Element("div", {
            styles: {
                height: "100%"
            }
        }).injectInside(item);

        if (moduleInfo.type == "skip" || moduleInfo.type == "placeholder")
            return;

        var height = moduleInfo.height || this.options.moduleHeight;

        var options = Object.merge({
            id: moduleInfo.id,
            height: height,
            eventHandler: this.eventHandler
        }, moduleInfo.options);

        if (moduleInfo.title)
            options.title = moduleInfo.title;

        var module = new Librarian.Modules[moduleInfo.type](options, moduleWrapper, false);

        module.moduleInfo = moduleInfo;
        module.load();
    },

    getSizeValue: function(value) {
        if (!value)
            return null;

        value = value.toString();

        if (value.contains('%'))
            return value;

        if (!value.contains('px'))
            value += 'px';

        return value;
    },

    parseStyles: function(styleString) {
        var styles = {};

        var nameValuePairs = styleString.split(';');
        nameValuePairs.forEach(function(pair) {
            var parts = pair.split(":");

            var name = parts[0],
                value = parts[1];

            if (name && value)
                styles[name.trim()] = value.trim();
        });

        return styles;
    }

});